import { THosStatus } from "hos-tools/src/interfaces/statues";
import { sanitizeUserName } from "../../../../../utils/users";

type TPillType = "default" | "info" | "success" | "warning" | "error";

export enum DisplayDetailEnum {
    default = "User",
    ChangeDriver = "Switch driver"
}

const HOS_STATUS_TO_PILL_TYPE_MAP: Record<string, TPillType> = {
    "ON": "warning",
    "D": "success",
    "OFF": "default",
    "SB": "error"
};

export const getHosPillType = (hosStatus: THosStatus): TPillType => {
    return HOS_STATUS_TO_PILL_TYPE_MAP[hosStatus] || "default";
};

export const moveDriverToFirst = (users: IUser[], activeDriverUsername: string): IUser[] => {
    if (!activeDriverUsername || users.length === 0) {
        return users;
    }

    const activeDriver = users.find(user => sanitizeUserName(user.name) === activeDriverUsername);
    if (!activeDriver || users[0] === activeDriver) {
        return users;
    }

    return [
        activeDriver,
        ...users.filter(user => user !== activeDriver)
    ];
};